import BaseFeature from '../../foundation/base/base';

class Pagination extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();
		this.el = element;
		this.disabledPagination = document.querySelectorAll('.m-pagination__link.is-disabled');
		this.activePagination = document.querySelector('.m-pagination__link.is-active');

		if (this.disabledPagination) {
			this.disabledPagination.forEach((el) => {
				el.setAttribute('tabindex', '-1');
			});
		}

		if (this.activePagination) {
			this.activePagination.setAttribute('tabindex', '-1');
		}
	}
}

export default Pagination;
